import { TableColumn } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';

export const createMissingProgrammingRecordsColumns = (): TableColumn[] => [
  {
    field: 'commDeviceId',
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.COMM_DEVICE_ID,
    width: 200,
    sortable: true
  },
  {
    field: 'initialTransmissionTime',
    title: TranslateRegistry.get.FILTER.TITLE.INITIAL_TRANSMISSION_TIME,
    width: 220,
    sortable: true
  },
  {
    field: 'lastTransmissionTime',
    title: TranslateRegistry.get.FILTER.TITLE.LAST_TRANSMISSION_TIME,
    width: 220,
    sortable: true
  }
];
